import LocationInfo from '../../components/refiDocs/LocationInfo';
import VehicleInfo from '../../components/refiDocs/VehicleInfo';
import TransactionInfoForm from '../../components/refiDocs/TransactionInfoForm';
import LienHolderInformation from '../../components/refiDocs/LienHolderINformation';
import FirstOwnerInformation from '../../components/refiDocs/FirstOwnerInformation';
import SecondOwnerInformation from '../../components/refiDocs/SecondOwnerInformation';
import { selectDocsError } from '../../redux-state/selectors';
import { useDispatch, useSelector } from 'react-redux';
import ErrorDialog from '../../components/common/error-dialog';

function RefiDocs({ errors, isMultiStep }) {
  const apiError = useSelector(selectDocsError);
  const dispatch = useDispatch();

  const handleCloseError = () => {
    dispatch({ type: 'CLEAR_DOCS_ERROR' });
  };

  return (
    <div className="flex flex-col lg:flex-row w-full gap-4">
      {/* Left side */}
      <div className="flex flex-col gap-6 mt-4 w-full lg:w-1/2">
        <LocationInfo errors={errors} />
        <VehicleInfo errors={errors} />
        <TransactionInfoForm errors={errors} />
      </div>

      {/* Right side */}
      <div className="flex flex-col gap-4 mt-4 w-full lg:w-1/2">
        <FirstOwnerInformation errors={errors} />
        <SecondOwnerInformation errors={errors} />
        <LienHolderInformation errors={errors} />
      </div>
       {!isMultiStep && <ErrorDialog backendError={apiError} onClose={handleCloseError} /> }
    </div>
  );
}

export default RefiDocs;
